import { useEffect, useRef } from 'react';

// REDUX
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { getPreloaderState, setPopupPanel } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { useDispatch } from 'react-redux';

export interface IStateType {}

export const UseKeyboardEvents = (): void => {
    const dispatch = useDispatch();
    const gameStorePreloaderState = useAppSelector(getPreloaderState);

    const gameStorePreloaderStateRef = useRef(gameStorePreloaderState);
    gameStorePreloaderStateRef.current = gameStorePreloaderState;

    useEffect(() => {}, []);

    function doubleKeyPressAction(key: string) {
        switch (key) {
            default:
                break;
        }
    }

    function keyPressAction(key: string) {
        switch (key) {
            case 'Escape':
                dispatch(setPopupPanel(false));
                break;
            case ' ':
                const preloaderState = gameStorePreloaderStateRef.current;
                if (preloaderState.active && preloaderState.availableActions?.continue) {
                    EventsCenter.emit(EGameEvents.PRELOADER_INTRO_MOVIE_SKIP);
                }

                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const delta = 500;
        let lastKeypressTime = 0;
        let lastKeypreesType = '';

        const keyDownAction = (e: { key: string }) => {
            let thisKeypressTime = new Date().getTime();
            if (thisKeypressTime - lastKeypressTime <= delta) {
                if (lastKeypreesType === e.key) {
                    doubleKeyPressAction(e.key);
                    thisKeypressTime = 0;
                    lastKeypreesType = '';
                }
            }
            lastKeypressTime = thisKeypressTime;
            lastKeypreesType = e.key;

            keyPressAction(e.key);
        };

        window.addEventListener('keydown', keyDownAction);

        return () => {
            window.removeEventListener('keydown', keyDownAction);
        };
    }, [dispatch]);
};
